import { forwardRef } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import Button from '../Button';
import Title from '../Title';
import ModalWrapper from './style/modalWrapper';

const Modal = forwardRef((props, ref) => {
  const {
    show,
    onClose,
    children,
    confirmation,
    question,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    className,
  } = props;
  if (!show) return null;

  return (
    <RemoveScroll noIsolation={false} removeScrollBar={false}>
      <ModalWrapper ref={ref} className={className}>
        <div
          className='modal-backdrop'
          onClick={onClose}
          onMouseDown={(e) => e.stopPropagation()}
        />
        <div
          className='modal-content'
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <button className='close-button' onClick={onClose}>
            ×
          </button>
          {confirmation ? (
            <div className='confirmation-box'>
              <Title size='SM' className='confirmation-text'>
                {question}
              </Title>
              <Button
                onClick={() => {
                  onConfirm?.();
                  onClose();
                }}
              >
                {confirmText}
              </Button>
              <Button className='modal-cancel-btn' onClick={onCancel || onClose}>
                {cancelText || 'Cancel'}
              </Button>
            </div>
          ) : (
            children
          )}
        </div>
      </ModalWrapper>
    </RemoveScroll>
  );
});

Modal.displayName = 'Modal';
export default Modal;
